import classNames from "classnames";
import React from 'react';
import "./Label.scss";

export interface IProps {
    as?:
    | "div"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "h7"
    | "label"
    | "span"
    | "p"
    | "em"
    | "pre";
    role?: string;
    ariaLevel?: number;
    attrs?: any;
    color?: spintrColors;
    className?: string;
    size?: spintrLabelSizes;
    style?: React.CSSProperties;
    weight?: spintrLabelFontweight;
    title?: string;
    children?: React.ReactNode;
    uppercase?: boolean;
    dangerouslySetInnerHTML?: any;
    lang?: string;
    centerText?: boolean;
    italic?: boolean;
    underline?: boolean;
    lineThrough?: boolean;
}

export function Label({
    ariaLevel,
    attrs,
    dangerouslySetInnerHTML,
    style,
    title,
    as = "div",
    centerText,
    children,
    className,
    color,
    italic,
    lang,
    lineThrough,
    role,
    size = "body-1",
    underline,
    uppercase,
    weight, 
}: IProps): JSX.Element {
    const Tag = as! as any;

    return (
        <Tag
            className={classNames(
                className,
                "label-component",
                `fs-${size}`,
                {
                    [`fc-${color}`]: !!color,
                    [`fw-${weight}`]: !!weight,
                    "uppercase": !!uppercase,
                    "subline-letter-spacing": !!uppercase,
                    "centerText": !!centerText,
                    "italic": !!italic,
                    "underline": !!underline,
                    "line-through": !!lineThrough
                }
            )}
            lang={lang}
            role={role}
            style={style}
            title={title}
            aria-level={ariaLevel}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
            {...attrs}
        >
            {children}
        </Tag>
    );
}

export default React.memo(Label);
